import Home from "./pages/home/Home";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useContext } from 'react';
import { Login } from "./pages/login/Login";
import { ForgotPwd } from "./pages/forgotPwd/ForgotPwd"
import CustomerList from './pages/customers/list/List'
import CustomerSingle from './pages/customers/single/Single'

import ContactList from './pages/contacts/list/List'
import ContactSingle from './pages/contacts/single/Single'

import SubscribersList from './pages/subscribers/list/List'
import SubscribersSingle from './pages/subscribers/single/Single'
import OutletsList from './pages/outlets/list/List'
import OutletsSingle from './pages/outlets/single/Single'
import PaymentsList from './pages/payments/list/List'
import PaymentsSingle from './pages/payments/single/Single'
import StaffList from "./pages/staff/list/List";
import StaffSingle from "./pages/staff/single/Single";
import StaffNew from "./pages/staff/new/New"; 
import StaffEdit from "./pages/staff/edit/Edit";
import NotificationList from "./pages/notifications/list/List";
import NotificationSingle from "./pages/notifications/single/Single";
import NotificationNew from "./pages/notifications/new/New"; 
import ReviewsList from "./pages/reviews/list/List";
import ReviewsSingle from "./pages/reviews/single/Single";
import AnalythicsList from "./pages/analythics/list/List";
import AnalythicsSingle from "./pages/analythics/single/Single";
import AnalythicsNew from "./pages/analythics/new/New"; 
import SettingsList from "./pages/settings/list/List";
import SettingsSingle from "./pages/settings/single/Single";
import SettingsNew from "./pages/settings/new/New"; 
import SettingsEdit from "./pages/settings/edit/Edit";
import PaymentList from "./pages/payments/list/List";
import PaymentSingle from "./pages/payments/single/Single";
import ProfileSingle from "./pages/profile/single/Single";
import MessageList from "./pages/messages/list/List";
import MessageSingle from "./pages/messages/single/Single";
import MessageNew from "./pages/messages/new/New"; 

import IndividualList from "./pages/individual/list/List";
import IndividualSingle from "./pages/individual/single/Single";
import IndividualNew from "./pages/individual/new/New"; 

import GroupList from "./pages/group/list/List";
import GroupSingle from "./pages/group/single/Single";
import GroupNew from "./pages/group/new/New"; 

import { staffInput, notificationInput, settingsInput} from "./data/formSource";
import './style/dark.scss'
import { DarkModeContext } from "./context/darkModeContext";
import { AuthContext } from "./context/AuthContext";
import OutletEdit from "./pages/outlets/edit/Edit";


import PaidList from './pages/paid/list/List'
import PaidSingle from './pages/paid/single/Single'
import PaidEdit from "./pages/paid/edit/Edit";

import UnPaidList from './pages/unpaid/list/List'
import UnPaidSingle from './pages/unpaid/single/Single'
import UnPaidEdit from "./pages/unpaid/edit/Edit";

import ReleaseList from "./pages/releases/list/List";
import ReleaseSingle from "./pages/releases/single/Single";
import ReleaseNew from "./pages/releases/new/New"; 


import AdvertList from "./pages/adverts/list/List";
import AdvertSingle from "./pages/adverts/single/Single";
import AdvertNew from "./pages/adverts/new/New"; 
import AdvertEdit from "./pages/adverts/edit/Edit";


import EventsList from "./pages/events/list/List";
import EventsSingle from "./pages/events/single/Single";
// import EventsNew from "./pages/events/new/New"; 
import EventsEdit from "./pages/events/edit/Edit";

import RewardList from "./pages/reward/list/List";
import RewardSingle from "./pages/reward/single/Single";
import RewardNew from "./pages/reward/new/New"; 
import RewardEdit from "./pages/reward/edit/Edit";

import CoinList from "./pages/coin/list/List";
import CoinSingle from "./pages/coin/single/Single";
import CoinNew from "./pages/coin/new/New"; 
import CoinEdit from "./pages/coin/edit/Edit";

import RewardLocationList from "./pages/rewardLocation/list/List";
import RewardLocationSingle from "./pages/rewardLocation/single/Single";
import RewardLocationNew from "./pages/rewardLocation/new/New"; 
import RewardLocationEdit from "./pages/rewardLocation/edit/Edit";

import PartnerRewardList from "./pages/partnerReward/list/List";
import PartnerRewardSingle from "./pages/partnerReward/single/Single";
import PartnerRewardNew from "./pages/partnerReward/new/New"; 
import PartnerRewardEdit from "./pages/partnerReward/edit/Edit";

// import EngagementAnalysisList from "./pages/engagementAnalysis/list/List";
// import EngagementAnalysisSingle from "./pages/engagementAnalysis/single/Single";
// import EngagementAnalysisNew from "./pages/engagementAnalysis/new/New"; 
// import EngagementAnalysisEdit from "./pages/engagementAnalysis/edit/Edit";

import StandardMessageList from "./pages/standardMessages/list/List";
import StandardMessageSingle from "./pages/standardMessages/single/Single";
import StandardMessageEdit from "./pages/standardMessages/edit/Edit";

import PremiumMessageList from "./pages/premiumMessages/list/List";
import PremiumMessageSingle from "./pages/premiumMessages/single/Single";
import PremiumMessageEdit from "./pages/premiumMessages/edit/Edit";

import LuxuryMessageList from "./pages/luxuryMessages/list/List";
import LuxuryMessageSingle from "./pages/luxuryMessages/single/Single";
import LuxuryMessageEdit from "./pages/luxuryMessages/edit/Edit";

import WeekendMessageList from "./pages/weekendMessages/list/List";
import WeekendMessageSingle from "./pages/weekendMessages/single/Single";
import WeekendMessageEdit from "./pages/weekendMessages/edit/Edit";




function App() {
  
  const { darkMode } = useContext(DarkModeContext)
  const { currentUser } = useContext(AuthContext)

  const RequireAuth = ({children}) => {
    return currentUser ? children : <Navigate to="/login"/>
  }

  return (
    <div className= {darkMode ? "app dark" : "app"}>
       <BrowserRouter>
        <Routes>
          <Route path="/">
          <Route path="login" element={<Login/>}/>
          <Route path="forgotPwd" element={<ForgotPwd/>}/>
            <Route index element={
            <RequireAuth>
                 <Home user={currentUser}/>
            </RequireAuth>
            
           } />

            <Route path="customers">
              <Route index element={
                <RequireAuth>
                 <CustomerList/>
              </RequireAuth>
              }/>
              <Route path=":customerId" element={
              <RequireAuth>
                  <CustomerSingle/>
              </RequireAuth>
              
              }/>
            
            </Route>


            <Route path="subscribers">
              <Route index element={
                <RequireAuth>
                 <SubscribersList/>
              </RequireAuth>
              }/>
              <Route path=":subscriberId" element={
              <RequireAuth>
                  <SubscribersSingle/>
              </RequireAuth>
              
              }/>
             
            </Route>

            <Route path="outlets">
              <Route index element={
                <RequireAuth>
                 <OutletsList/>
              </RequireAuth>
              }/>
              <Route path=":outletId" element={
              <RequireAuth>
                  <OutletsSingle/>
              </RequireAuth>
              
              }/>
              <Route path="/outlets/edit/:outletId" element={
              <RequireAuth>
                  <OutletEdit/>
              </RequireAuth>
              
              }/>
            
            </Route>


             <Route path="contacts">
              <Route index element={
                <RequireAuth>
                 <ContactList/>
              </RequireAuth>
              }/>
              <Route path=":contactId" element={
              <RequireAuth>
                  <ContactSingle/>
              </RequireAuth>
              
              }/>
            
            </Route>


             <Route path="paid">
              <Route index element={
                <RequireAuth>
                 <PaidList/>
              </RequireAuth>
              }/>
              <Route path=":paidId" element={
              <RequireAuth>
                  <PaidSingle/>
              </RequireAuth>
              
              }/>
              <Route path="/paid/edit/:paidId" element={
              <RequireAuth>
                  <PaidEdit/>
              </RequireAuth>
              
              }/>
            
            </Route>


            <Route path="unpaid">
              <Route index element={
                <RequireAuth>
                 <UnPaidList/>
              </RequireAuth>
              }/>
              <Route path=":unpaidId" element={
              <RequireAuth>
                  <UnPaidSingle/>
              </RequireAuth>
              
              }/>
              <Route path="/unpaid/edit/:unpaidId" element={
              <RequireAuth>
                  <UnPaidEdit/>
              </RequireAuth>
              
              }/>
            
            </Route>

              <Route path="group">
              <Route index element={
                <RequireAuth>
                  <GroupList/>
                </RequireAuth>
              }/>
              <Route path=":groupId" element={
              <RequireAuth>
                  <GroupSingle/>
              </RequireAuth>
              }/>

            <Route path="new" element={
                <RequireAuth>
                  <GroupNew title="Add New Group Notification"/>
                </RequireAuth>
              }/>

              </Route>

              <Route path="individual">
              <Route index element={
                <RequireAuth>
                  <IndividualList/>
                </RequireAuth>
              }/>
              <Route path=":individualId" element={
              <RequireAuth>
                  <IndividualSingle/>
              </RequireAuth>
              }/>

            <Route path="new" element={
                <RequireAuth>
                  <IndividualNew title="Add New Individual Notification"/>
                </RequireAuth>
              }/>

            </Route>


            <Route path="releases">
              <Route index element={
                <RequireAuth>
                  <ReleaseList/>
                </RequireAuth>
              }/>
              <Route path=":releaseId" element={
              <RequireAuth>
                  <ReleaseSingle/>
              </RequireAuth>
              }/>

            <Route path="new" element={
                <RequireAuth>
                  <ReleaseNew title="Add New Future Releases"/>
                </RequireAuth>
              }/>

            </Route>


            <Route path="payments">
              <Route index element={
                <RequireAuth>
                 <PaymentsList/>
              </RequireAuth>
              }/>
              <Route path=":paymentId" element={
              <RequireAuth>
                  <PaymentsSingle/>
              </RequireAuth>
              
              }/>
           
            </Route>


            <Route path="messages">
              <Route index element={
                <RequireAuth>
                  <MessageList/>
                </RequireAuth>
              }/>
              <Route path=":messageId" element={
              <RequireAuth>
                  <MessageSingle/>
              </RequireAuth>
              }/>

            <Route path="new" element={
                <RequireAuth>
                  <MessageNew title="Add New Message"/>
                </RequireAuth>
              }/>

            </Route>


            <Route path="analythics">
              <Route index element={
                <RequireAuth>
                  <AnalythicsList/>
                </RequireAuth>
              }/> 
            <Route path=":analyticId" element={
              <RequireAuth>
                  <AnalythicsSingle/>
              </RequireAuth>
              }/> 

            <Route path="new" element={
                <RequireAuth>
                  <AnalythicsNew title="Add New Analytic"/>
                </RequireAuth>
              }/>

            </Route>
              
             <Route path="staff">
              <Route index element={
               <RequireAuth>
                <StaffList />
               </RequireAuth>
              }/>
              <Route path=":staffId" element={
                <RequireAuth>
                 <StaffSingle/>
                </RequireAuth>
              }/>
              <Route path="new" element={
                <RequireAuth>
                  <StaffNew inputs={staffInput} title="Add New Staff"/>
                </RequireAuth>
              }/>
              <Route path="/staff/edit/:staffId" element={
              <RequireAuth>
                  <StaffEdit/>
              </RequireAuth>
              
              }/>
              </Route>

             <Route path="settings">
              <Route index element={
               <RequireAuth>
                <SettingsList />
               </RequireAuth>
              }/>
              <Route path=":settingsId" element={
                <RequireAuth>
                 <SettingsSingle/>
                </RequireAuth>
              }/>
              <Route path="new" element={
                <RequireAuth>
                  <SettingsNew inputs={settingsInput} title="Add Settings"/>
                </RequireAuth>
              }/>
              <Route path="/settings/edit/:settingsId" element={
              <RequireAuth>
                  <SettingsEdit/>
              </RequireAuth>
              
              }/>
              </Route>

            </Route>
      
            <Route path="notifications">
              <Route index element={
               <RequireAuth>
                <NotificationList />
               </RequireAuth>
              }/>
              <Route path=":notificationId" element={
                <RequireAuth>
                 <NotificationSingle/>
                </RequireAuth>
              }/>
              <Route path="new" element={
                <RequireAuth>
                  <NotificationNew inputs={notificationInput} title="Add New Notification"/>
                </RequireAuth>
              }/>
            </Route>
            <Route path="reviews">
              <Route index element={
               <RequireAuth>
                <ReviewsList />
               </RequireAuth>
              }/>
              <Route path=":reviewId" element={
                <RequireAuth>
                 <ReviewsSingle/>
                </RequireAuth>
              }/>
            
              </Route>

            <Route path="payments">
              <Route index element={
                <RequireAuth>
                  <PaymentList/>
                </RequireAuth>
              }/>
              <Route path=":paymentId" element={
              <RequireAuth>
                  <PaymentSingle/>
              </RequireAuth>
              }/>
            
            </Route>

            <Route path=":profileId">
              <Route index element={
                <RequireAuth>
                  <ProfileSingle/>
                </RequireAuth>
               
              }/>
            </Route>


            <Route path="adverts">
              <Route index element={
                <RequireAuth>
                  <AdvertList/>
                </RequireAuth>
              }/>
              <Route path=":advertId" element={
              <RequireAuth>
                  <AdvertSingle/>
              </RequireAuth>
              }/>

              <Route path="new" element={
                <RequireAuth>
                  <AdvertNew title="Add New Advert"/>
                </RequireAuth>
              }/>

              <Route path="/adverts/edit/:advertId" element={
              <RequireAuth>
                  <AdvertEdit/>
              </RequireAuth>
              
              }/>

            </Route>

              <Route path="events">
              <Route index element={
                <RequireAuth>
                  <EventsList/>
                </RequireAuth>
              }/>
              <Route path=":eventId" element={
              <RequireAuth>
                  <EventsSingle/>
              </RequireAuth>
              }/>

              <Route path="/events/edit/:eventId" element={
              <RequireAuth>
                  <EventsEdit/>
              </RequireAuth>
              
              }/>

            </Route>

              <Route path="reward">
              <Route index element={
                <RequireAuth>
                  <RewardList/>
                </RequireAuth>
              }/>
              <Route path=":rewardId" element={
              <RequireAuth>
                  <RewardSingle/>
              </RequireAuth>
              }/>

              <Route path="new" element={
                <RequireAuth>
                  <RewardNew title="Add New Reward"/>
                </RequireAuth>
              }/>

              <Route path="/reward/edit/:rewardId" element={
              <RequireAuth>
                  <RewardEdit/>
              </RequireAuth>
              
              }
              />

            </Route>


             <Route path="coin">
              <Route index element={
                <RequireAuth>
                  <CoinList/>
                </RequireAuth>
              }/>
              <Route path=":coinId" element={
              <RequireAuth>
                  <CoinSingle/>
              </RequireAuth>
              }/>

              <Route path="new" element={
                <RequireAuth>
                  <CoinNew title="Add New Coin"/>
                </RequireAuth>
              }/>

              <Route path="/coin/edit/:coinId" element={
              <RequireAuth>
                  <CoinEdit/>
              </RequireAuth>
              
              }/>

            </Route>

              <Route path="rewardlocation">
              <Route index element={
                <RequireAuth>
                  <RewardLocationList/>
                </RequireAuth>
              }/>
              <Route path=":rewardlocationId" element={
              <RequireAuth>
                  <RewardLocationSingle/>
              </RequireAuth>
              }/>

              <Route path="new" element={
                <RequireAuth>
                  <RewardLocationNew title="Add New Reward Location"/>
                </RequireAuth>
              }/>

              <Route path="/rewardlocation/edit/:rewardlocationId" element={
              <RequireAuth>
                  <RewardLocationEdit/>
              </RequireAuth>
              
              }/>

            </Route>


             <Route path="partnerReward">
              <Route index element={
               <RequireAuth>
                <PartnerRewardList />
               </RequireAuth>
              }/>
              <Route path=":partnerRewardId" element={
                <RequireAuth>
                 <PartnerRewardSingle/>
                </RequireAuth>
              }/>
              <Route path="new" element={
                <RequireAuth>
                  <PartnerRewardNew title="Add Partner Reward"/>
                </RequireAuth>
              }/>
              <Route path="/partnerReward/edit/:settingsId" element={
              <RequireAuth>
                  <PartnerRewardEdit/>
              </RequireAuth>
              
              }/>
              </Route>


            {/* <Route path="engagementAnalysis">
              <Route index element={
               <RequireAuth>
                <EngagementAnalysisList />
               </RequireAuth>
              }/>
              <Route path=":engagementAnalysisId" element={
                <RequireAuth>
                 <EngagementAnalysisSingle/>
                </RequireAuth>
              }/>
              <Route path="new" element={
                <RequireAuth>
                  <EngagementAnalysisNew title="Add Engagement Analysis"/>
                </RequireAuth>
              }/>
              <Route path="/engagementAnalysis/edit/:engagementAnalysisId" element={
              <RequireAuth>
                  <EngagementAnalysisEdit/>
              </RequireAuth>
              
              }/>
            </Route> */}


             <Route path="standardmessages">
              <Route index element={
               <RequireAuth>
                <StandardMessageList />
               </RequireAuth>
              }/>
              <Route path=":standardmessageId" element={
                <RequireAuth>
                 <StandardMessageSingle/>
                </RequireAuth>
              }/>
              <Route path="/standardmessages/edit/:standardmessageId" element={
              <RequireAuth>
                  <StandardMessageEdit/>
              </RequireAuth>
              
              }/>
            </Route>


            <Route path="premiummessages">
              <Route index element={
               <RequireAuth>
                <PremiumMessageList />
               </RequireAuth>
              }/>
              <Route path=":premiummessageId" element={
                <RequireAuth>
                 <PremiumMessageSingle/>
                </RequireAuth>
              }/>
            
              <Route path="/premiummessages/edit/:premiummessageId" element={
              <RequireAuth>
                  <PremiumMessageEdit/>
              </RequireAuth>
              
              }/>
            </Route>


            <Route path="luxurymessages">
              <Route index element={
               <RequireAuth>
                <LuxuryMessageList />
               </RequireAuth>
              }/>
              <Route path=":luxurymessageId" element={
                <RequireAuth>
                 <LuxuryMessageSingle/>
                </RequireAuth>
              }/>
            
              <Route path="/luxurymessages/edit/:luxurymessageId" element={
              <RequireAuth>
                  <LuxuryMessageEdit/>
              </RequireAuth>
              
              }/>
            </Route>


            <Route path="weekendmessages">
              <Route index element={
               <RequireAuth>
                <WeekendMessageList/>
               </RequireAuth>
              }/>
              <Route path=":weekendmessageId" element={
                <RequireAuth>
                 <WeekendMessageSingle/>
                </RequireAuth>
              }/>
            
              <Route path="/weekendmessages/edit/:weekendmessageId" element={
              <RequireAuth>
                  <WeekendMessageEdit/>
              </RequireAuth>
              
              }/>

            </Route>

        </Routes>

  </BrowserRouter>

    </div>

  );

}

export default App;
